<div mat-dialog-header class="title">
    Tagged Muckpile Details
</div>
<div mat-dialog-content class="dialog-content">
    <div class="section flex-percent flex-wrapper main-content">
        <div class="container container-33">
            <div class="full-width half-height muckpile-map">
                <div #map class="full-height full-width"></div>
            </div>
            <!-- Muckpile Statistics Table -->
            <div class="table-container p mt-10 full-width">
                <mat-card class="full-width static-data-content">
                    <div *ngIf="(taggedMuckpile$ | async) === undefined"
                        class="container centered-content full-width half-height">
                        <mat-spinner strokeWidth="3" [diameter]="50"></mat-spinner>
                    </div>
                    <div *ngIf="(taggedMuckpile$ | async) === null" class="container centered-content">
                        <div class="container centered-content">
                            <div>
                                <mat-icon svgIcon="empty-data" class="not-found-svg"></mat-icon>
                            </div>
                            <div>No Data Found</div>
                        </div>
                    </div>
                    <muckpile-statistics 
                        [details]="(taggedMuckpile$ | async)?.details"
                        [areaUnit]="areaUnit$ | async"
                        [particleSizeUnit]="particleSizeUnit$ | async">
                    </muckpile-statistics>
                </mat-card>
            </div>
        </div>
        <div class="container container-67 flex-column">
            <mat-card>
                <ng-container class="chart-containers">
                    <div class="container centered-content map-title">
                        <caption class="mt-1 text-underline font-bold">Imported Muckpile Fragmentation</caption>
                    </div>
                    <div class="charts-content cards">
                        <div *ngIf="(taggedMuckpile$ | async) === undefined" class="container centered-content">
                            <mat-spinner strokeWidth="3" [diameter]="50"></mat-spinner>
                        </div>
                        <div *ngIf="(taggedMuckpile$ | async) === null" class="container centered-content">
                            <div class="container centered-content">
                                <div>
                                    <mat-icon svgIcon="empty-data" class="not-found-svg"></mat-icon>
                                </div>
                                <div>No Data Found</div>
                            </div>
                        </div>
                        <div class="chart-half-height">
                            <div *ngIf="!(taggedMuckpile$ | async).imported_fragmentation.psd?.length"
                                class="container chart-container centered-content">
                                <div class="container centered-content">
                                    <div>
                                        <mat-icon svgIcon="empty-data" class="not-found-svg"></mat-icon>
                                    </div>
                                    <div>Not an Imported Muckpile</div>
                                </div>
                            </div>
                            <div class="container chart-container chart-fragment-container"
                                *ngIf="(taggedMuckpile$ | async).imported_fragmentation.psd?.length">
                                <psd-chart class="chart-containers" [index]="0"
                                    [muckpileData]="(taggedMuckpile$ | async).imported_fragmentation"
                                    [type]="'muckpile'"></psd-chart>
                            </div>
                        </div>
                        <div *ngIf="(muckpileData$ | async) === undefined" class="container centered-content">
                            <mat-spinner strokeWidth="3" [diameter]="50"></mat-spinner>
                        </div>
                            <div *ngIf="(muckpileData$ | async)?.actual_fragmentation as actualFragment">
                                <div *ngIf="isEmptyObject(actualFragment)" class="container centered-content">
                                    <mat-icon svgIcon="empty-data" class="not-found-svg"></mat-icon>
                                    <div>No Intervals/Dumps Tagged</div>
                                </div>
                                <div *ngIf="!isEmptyObject(actualFragment)">
                                    <div class="centered-content">
                                        <caption class="mt-1 text-underline font-bold">Tagged Data Fragmentation
                                        </caption>
                                    </div>
                                    <div class="container chart-fragment-container actual-fragment-content">
                                        <psd-chart [index]="0" [muckpileData]="actualFragment"
                                            [type]="'muckpile'"></psd-chart>
                                    </div>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </mat-card>
        </div>
    </div>
</div>
<div mat-dialog-actions class="btn-container">
    <button mat-button color="primary" class="close-btn" (click)="cancel()">Close</button>
</div>